import React, { useEffect } from "react";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";

const DEFAULT_API_HOST = "/ingest-dnx/";
const DEFAULT_UI_HOST = "https://eu.posthog.com";

const devLog = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.warn(...args);
  }
};

export function PostHogProvider({ children }) {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    if (process.env.POSTHOG_DISABLE === "true") {
      devLog("[PostHog] POSTHOG_DISABLE=true. Skipping init.");
      return;
    }

    const key =
      process.env.VITE_PUBLIC_POSTHOG_KEY ||
      process.env.POSTHOG_API_KEY;
    const apiHost =
      process.env.VITE_PUBLIC_POSTHOG_HOST ||
      process.env.POSTHOG_API_HOST ||
      DEFAULT_API_HOST;
    const uiHost = process.env.POSTHOG_UI_HOST || DEFAULT_UI_HOST;

    if (!key) {
      devLog("[PostHog] Missing POSTHOG_API_KEY. Skipping PostHog init.");
      return;
    }

    if (!posthog.__loaded) {
      posthog.init(key, {
        api_host: apiHost,
        ui_host: uiHost,
        capture_exceptions: true,
        capture_pageview: true,
        capture_pageleave: true,
        debug: process.env.NODE_ENV === "development",
      });
    }

    return () => {
      if (process.env.NODE_ENV === "development") {
        try {
          posthog.reset();
        } catch (error) {
          devLog("[PostHog] Error during reset:", error);
        }
      }
    };
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}

export default PostHogProvider;

